import { makeOpenApiMethod } from "./make-openapi-method";

export const getChainNonprofits = makeOpenApiMethod("/chain/{chainId}/nonprofits", "get", 200);

export const getImpact = makeOpenApiMethod("/impact", "get", 200);

export const postSelectNonprofit = makeOpenApiMethod("/selectNonprofit", "post", 201);

export const postTransaction = makeOpenApiMethod("/transaction", "post", 201);

export const putTransaction = makeOpenApiMethod("/transaction/{transactionId}", "put", 204);

export const postCart = makeOpenApiMethod("/cart", "post", 201);
